import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-initiatives',
  templateUrl: './quality-initiatives.component.html',
  styleUrls: ['./quality-initiatives.component.scss']
})
export class QualityInitiativesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
